import { IKnmErknmFormOrganizationAdd } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormOrganizationAdd';
import { IKnmErknmFormSubject } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormSubject';

export function isKnmSubjectExist(
  key: 'inn' | 'ogrn' | 'rafpNza' | 'snils' | 'organizationName',
  listId: string,
  organizations: IKnmErknmFormSubject[] | IKnmErknmFormOrganizationAdd[] | undefined,
  errorMsg: string | undefined,
) {
  return (value: string) => {
    if (!organizations || !errorMsg) {
      return undefined;
    }

    const isExist = !!organizations?.find(
      org => org[key]?.toString().toLocaleLowerCase() === value.toString().toLocaleLowerCase() && org.listId !== listId,
    );

    return isExist ? errorMsg : undefined;
  };
}
